module.exports = __webpack_public_path__ + "static/media/add.b2fe778f.svg";